/** @format */

import { useState, useCallback, useEffect } from 'react';
import * as listedLeadService from '../services/listedLeadsService';
import { ListedLead, ListedLeadFilterInput } from '../types/listedLeads.types';

interface UseListedLeadsReturn {
  listedLeads: ListedLead[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Custom hook for fetching and managing listed leads
 */
export const useListedLeads = (filter?: ListedLeadFilterInput): UseListedLeadsReturn => {
  const [listedLeads, setListedLeads] = useState<ListedLead[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchListedLeads = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await listedLeadService.getListedLeads(filter);
      setListedLeads(data);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to fetch listed leads';
      setError(errorMessage);
      console.error('Error fetching listed leads:', err);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    fetchListedLeads();
  }, [fetchListedLeads]);

  return {
    listedLeads,
    loading,
    error,
    refetch: fetchListedLeads,
  };
};
